"use strict";

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _regeneratorRuntime = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var apisauce_1 = require("apisauce");

var errorHandling_1 = require("@widergy/web-utils/lib/errorHandling");

var web_utils_1 = require("@widergy/web-utils");

var DEFAULT_INTERVAL = 1000;
var DEFAULT_TIMEOUT = 70000;
var POLLING_TIMEOUT_ERROR = 'PollingTimeoutError';
var api = apisauce_1.create({
  baseURL: 'localhost',
  timeout: 30000
});

var PollingTimeoutError = /*#__PURE__*/function (_Error) {
  _inherits(PollingTimeoutError, _Error);

  var _super = _createSuper(PollingTimeoutError);

  function PollingTimeoutError(message) {
    var _this;

    _classCallCheck(this, PollingTimeoutError);

    _this = _super.call(this, message);
    _this.message = message;
    _this.name = POLLING_TIMEOUT_ERROR;
    return _this;
  }

  return PollingTimeoutError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var pollResource = function pollResource(url, interval, timeout, headers, failureCallback, originalUrl) {
  var endTime = new Date().getTime() + timeout;

  var pollingRequest = function pollingRequest(resolve, reject) {
    api.get(url, {}, {
      baseURL: '',
      headers: headers
    }).then(function (response) {
      if (response.status === 202) {
        if (new Date().getTime() < endTime) {
          setTimeout(pollingRequest, interval, resolve, reject);
        } else {
          if (failureCallback) {
            failureCallback(response, {
              name: POLLING_TIMEOUT_ERROR,
              originalUrl: originalUrl,
              timeout: timeout
            });
          }

          reject(new PollingTimeoutError("Polling timed out on url: ".concat(url)));
        }
      } else if (response.ok) {
        resolve(response);
      } else {
        if (errorHandling_1.existsErrorCode(web_utils_1.ERROR_CODES.GATEWAY_TIMEOUT, response.data)) failureCallback(response, {
          name: POLLING_TIMEOUT_ERROR,
          originalUrl: originalUrl,
          timeout: timeout
        });
        reject(response);
      }
    }).catch(reject);
  };

  return new Promise(pollingRequest);
};

var poll = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(baseUrl, request, failureCallback, originalUrl) {
    var timeout,
        interval,
        response,
        url,
        headers,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            timeout = _args.length > 4 && _args[4] !== undefined ? _args[4] : DEFAULT_TIMEOUT;
            interval = _args.length > 5 && _args[5] !== undefined ? _args[5] : DEFAULT_INTERVAL;
            _context.next = 4;
            return request;

          case 4:
            response = _context.sent;
            url = "".concat(baseUrl).concat(response.data.job_id ? response.data.job_id : response.data.response);

            if (response.data.token) {
              response.config.headers.Authorization = response.data.token;
            } else delete response.config.headers['Authorization'];

            headers = response.config && response.config.headers;
            return _context.abrupt("return", pollResource(url, interval, timeout, headers, failureCallback, originalUrl));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function poll(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var Polling = /*#__PURE__*/function () {
  function Polling() {
    var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var failureCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Function;

    _classCallCheck(this, Polling);

    this.baseUrl = baseUrl;
    this.failureCallback = failureCallback;
  }

  _createClass(Polling, [{
    key: "init",
    value: function init(baseUrl, monitors, failureCallback) {
      this.baseUrl = baseUrl;
      this.failureCallback = failureCallback;
      if (monitors) monitors.forEach(function (monitor) {
        api.addMonitor(monitor);
      });
    }
  }, {
    key: "handle",
    value: function () {
      var _handle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(originalRequest, timeout) {
        var request, originalUrl, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return originalRequest;

              case 2:
                request = _context2.sent;
                originalUrl = request.config.url;
                response = {};

                if (request.ok) {
                  _context2.next = 9;
                  break;
                }

                response.error = errorHandling_1.getResponseError(request);
                response.status = request.status;
                return _context2.abrupt("return", response);

              case 9:
                return _context2.abrupt("return", poll(this.baseUrl, request, this.failureCallback, originalUrl, timeout).then(function (result) {
                  response.data = result.data;
                  return response;
                }).catch(function (err) {
                  response.error = errorHandling_1.getResponseError(err);
                  response.status = err.status;
                  response.originalUrl = originalUrl;
                  return response;
                }));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handle(_x5, _x6) {
        return _handle.apply(this, arguments);
      }

      return handle;
    }()
  }]);

  return Polling;
}();

exports.default = new Polling();